// Thème Marggi. Sans script, tout fonctionne en Shopify natif (formulaires, liens) ; le script ajoute
// le tiroir panier, le changement de coloris sur place, la galerie et les animations.
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const calme = matchMedia("(prefers-reduced-motion: reduce)").matches;
const T = window.TEXTES || {};
const LANGUE = document.documentElement.lang || "fr";
const argent = (centimes) =>
  new Intl.NumberFormat(LANGUE, { style: "currency", currency: window.DEVISE || "EUR" }).format(centimes / 100);
const pluriel = (n, un, plusieurs) => (n > 1 ? plusieurs : un).replace("%n", n);
const largeur = (u, w) => `${u}${u.includes("?") ? "&" : "?"}width=${w}`;
const echapper = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
const ICONE = {
  croix: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
  moins: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg>',
  plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M12 5v14"/></svg>',
  corbeille: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>',
};
document.documentElement.classList.add("js");

// Catalogue : filtre par type de produit.
document.addEventListener("click", (e) => {
  const b = e.target.closest(".onglets button");
  if (!b) return;
  $$(".onglets button").forEach((x) => x.setAttribute("aria-pressed", x === b));
  $$(".grille li[data-cat]").forEach((li) => (li.hidden = b.dataset.cat && li.dataset.cat !== b.dataset.cat));
});
$$(".fleche").forEach((f) => f.addEventListener("click", () => $(".onglets").scrollBy({ left: f.dataset.sens * 200 })));

// Grille : une pastille change la carte sur place (photo, lien, nom, prix).
document.addEventListener("click", (e) => {
  const p = e.target.closest(".grille .pastille");
  if (!p || !p.dataset.src) return;
  e.preventDefault();
  const li = p.closest("li");
  const img = $(".visuel img", li);
  if (img) {
    img.removeAttribute("srcset");
    img.src = p.dataset.src;
    img.alt = p.dataset.nom;
  }
  $(".carte", li).href = p.href;
  $(".nom", li).textContent = p.dataset.nom;
  $(".prix", li).textContent = p.dataset.prix;
  $$(".pastille", li).forEach((x) => x.setAttribute("aria-current", x === p));
});

// Fiche : flèches et points de la galerie ; le défilement au doigt les tient à jour.
document.addEventListener("click", (e) => {
  const b = e.target.closest(".cadre .nav");
  if (!b) return;
  const defile = $(".defile");
  defile.scrollBy({ left: (b.classList.contains("suiv") ? 1 : -1) * defile.clientWidth, behavior: calme ? "auto" : "smooth" });
});
document.addEventListener("scroll", (e) => {
  const d = e.target;
  if (!d.classList?.contains("defile")) return;
  const i = Math.round(d.scrollLeft / d.clientWidth);
  $$(".cadre .points span").forEach((s, j) => s.toggleAttribute("aria-current", i === j));
  const prec = $(".cadre .prec"), suiv = $(".cadre .suiv");
  if (prec) prec.disabled = i === 0;
  if (suiv) suiv.disabled = i >= d.children.length - 1;
}, true);

// Fiche : la taille choisie fixe la variante du formulaire et le prix affiché.
document.addEventListener("click", (e) => {
  const b = e.target.closest(".tailles button");
  if (!b || b.disabled) return;
  $$(".tailles button").forEach((x) => x.setAttribute("aria-pressed", x === b));
  $('.form-produit input[name="id"]').value = b.dataset.id;
  $("[data-prix]").textContent = b.dataset.prix;
  majMulti();
});

// Fiche : « Ajouter aussi en » ; le coloris de la page part toujours, les autres cochés le rejoignent dans la même taille.
// Le bouton annonce le nombre d'articles et le total ; un coloris épuisé dans cette taille le dit.
const tailleChoisie = () => $('.tailles [aria-pressed="true"]')?.textContent.trim() ?? "Default Title";
const taillesDe = (c) => Object.fromEntries(c.dataset.tailles.split(";").filter(Boolean).map((x) => { const [t, id, prix] = x.split("|"); return [t, { id, prix: +prix }]; }));
const autresCoches = () => $$(".multi input:checked").map((c) => taillesDe(c)[tailleChoisie()]).filter(Boolean);
function majMulti() {
  const form = $(".form-produit");
  const bouton = $('[type="submit"]', form || document);
  if (!form || !$(".multi")) return;
  const taille = tailleChoisie();
  for (const c of $$(".multi input")) {
    c.disabled = !(taille in taillesDe(c));
    if (c.disabled) c.checked = false;
    $("small", c.parentElement).textContent = c.disabled ? T.epuise_en.replace("%s", taille) : "";
  }
  bouton.dataset.texte ??= bouton.textContent;
  const autres = autresCoches();
  const prixCourant = +($('.tailles [aria-pressed="true"]')?.dataset.centimes ?? form.dataset.centimes);
  const total = autres.reduce((s, a) => s + a.prix, prixCourant);
  bouton.textContent = autres.length ? T.plusieurs.replace("%n", autres.length + 1).replace("%s", argent(total)) : bouton.dataset.texte;
}
document.addEventListener("change", (e) => e.target.closest(".multi") && majMulti());
document.addEventListener("change", (e) => {
  const s = e.target.closest(".choix-variante select");
  if (s) $("[data-prix]").textContent = s.selectedOptions[0].dataset.prix;
});

// Fiche : un autre coloris remplace la fiche sur place ; l'adresse suit, le retour arrière aussi.
async function changerProduit(url, empiler) {
  try {
    const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), "text/html");
    const remplacer = () => {
      $(".produit").replaceWith($(".produit", doc));
      majMulti();
      const reco = $(".recommandations", doc);
      if (reco && $(".recommandations")) { $(".recommandations").replaceWith(reco); chargerRecommandations(); }
      document.title = doc.title;
      $$('meta[name="description"], link[rel="canonical"], script[type="application/ld+json"]', document.head).forEach((n) => n.remove());
      $$('meta[name="description"], link[rel="canonical"]', doc.head).forEach((n) => document.head.append(n));
      $$('main script[type="application/ld+json"]').forEach((n) => n.remove());
      $$('main script[type="application/ld+json"]', doc).forEach((n) => $("main").append(n));
    };
    if (empiler) history.pushState({}, "", url);
    document.startViewTransition && !calme ? document.startViewTransition(remplacer) : remplacer();
  } catch {
    location.href = url;
  }
}
document.addEventListener("click", (e) => {
  const p = e.target.closest(".coloris .pastille");
  if (!p || e.metaKey || e.ctrlKey) return;
  e.preventDefault();
  if (p.getAttribute("aria-current") !== "true") changerProduit(p.href, true);
});
addEventListener("popstate", () => $(".produit") && changerProduit(location.href, false));

// « Vous aimerez aussi » : section rendue par Shopify, chargée après la page.
async function chargerRecommandations() {
  const bloc = $(".recommandations[data-url]");
  if (!bloc || bloc.children.length) return;
  try {
    const doc = new DOMParser().parseFromString(await (await fetch(bloc.dataset.url)).text(), "text/html");
    const rendu = $(".recommandations", doc);
    if (rendu) bloc.innerHTML = rendu.innerHTML;
  } catch {}
}
chargerRecommandations();

// Panier Shopify (API Ajax) : le tiroir s'ouvre à chaque ajout et depuis l'icône.
const lienPanier = $(".icone-panier");
const api = (url, corps) =>
  fetch(url, corps ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(corps) } : { headers: { Accept: "application/json" } })
    .then((r) => (r.ok ? r.json() : Promise.reject(r)));
const lirePanier = () => api(`${routes.panier}.js`);

function afficherCompte(n) {
  lienPanier.dataset.compte = n || "";
  lienPanier.setAttribute("aria-label", n ? T.compte.replace("%n", n) : T.compte_vide);
}

const tiroir = document.createElement("aside");
tiroir.className = "tiroir";
tiroir.setAttribute("role", "dialog");
const ICONE_APPLE = '<svg class="marque-apple" viewBox="0 0 384 512" aria-hidden="true"><path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/></svg>';
const ICONE_GOOGLE = '<svg class="marque-google" viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>';
tiroir.setAttribute("aria-modal", "true");
tiroir.setAttribute("aria-labelledby", "tiroir-titre");
tiroir.inert = true;
tiroir.innerHTML = `
  <header><h2 id="tiroir-titre"></h2><button type="button" class="fermer" aria-label="${echapper(T.fermer)}">${ICONE.croix}</button></header>
  <div class="tiroir-corps">
    <p class="vide">${echapper(T.vide)} <a href="${echapper(routes.collections)}">${echapper(T.voir)}</a></p>
    <p class="erreur" role="alert" hidden></p>
    <ul class="lignes"></ul>
    <div class="infos">
      <details class="bloc"><summary>${echapper(T.paiement)}</summary><div><p>${echapper(T.paiement_texte)}</p></div></details>
      <details class="bloc"><summary>${echapper(T.expedition)}</summary><div><p>${echapper(T.expedition_texte)}</p></div></details>
    </div>
    <section class="look" hidden><h3>${echapper(T.look)}</h3><div class="look-liste"></div></section>
  </div>
  <footer>
    <form action="${echapper(routes.panier)}" method="post"><button class="acheter commander" type="submit" name="checkout"></button></form>
    <p class="note">${echapper(T.note)}</p>
  </footer>`;
// Paiements express sous « Passer la commande » : les vrais boutons Shopify quand la boutique les a activés (un geste) ;
// sinon les mêmes boutons que la fiche, qui mènent au paiement Shopify.
let appareil;
const paiements = $("#paiements-rapides");
if (paiements?.children.length) {
  $("footer form", tiroir).after(paiements);
  paiements.hidden = false;
} else {
  const lien = (classe, nom, contenu, cache) => `<a class="express ${classe}" href="/checkout" aria-label="${echapper(T.payer_avec.replace("%s", nom))}"${cache ? " hidden" : ""}>${contenu}</a>`;
  const boutons = document.createElement("div");
  boutons.className = "paiements";
  boutons.innerHTML = lien("apple-pay", "Apple Pay", `${ICONE_APPLE}<span>Pay</span>`, true)
    + lien("google-pay", "Google Pay", `${ICONE_GOOGLE}<span>Pay</span>`, true)
    + lien("paypal", "PayPal", "<b>Pay</b><i>Pal</i>", false);
  $("footer form", tiroir).after(boutons);
  filtrerExpress(boutons);
}
const fond = Object.assign(document.createElement("div"), { className: "tiroir-fond" });
document.body.append(fond, tiroir);
let retourFocus;

function ligneHTML(item) {
  const variante = item.product_has_only_default_variant ? "" : `<p>${echapper(item.variant_title)}</p>`;
  const image = item.image ? `<img src="${echapper(largeur(item.image, 200))}" alt="">` : "";
  return `<li data-cle="${echapper(item.key)}">
    <a class="mini" href="${echapper(item.url)}">${image}</a>
    <div><a class="nom-ligne" href="${echapper(item.url)}">${echapper(item.product_title)}</a>${variante}
      <div class="qte"><button type="button" data-qte="${item.quantity - 1}" aria-label="${echapper(T.moins)}">${ICONE.moins}</button><span>${item.quantity}</span><button type="button" data-qte="${item.quantity + 1}" aria-label="${echapper(T.plus)}">${ICONE.plus}</button></div></div>
    <div class="droite"><p>${argent(item.final_line_price)}</p><button type="button" class="suppr" data-qte="0" aria-label="${echapper(`${T.supprimer} ${item.product_title}`)}">${ICONE.corbeille}</button></div>
  </li>`;
}

async function rendreSuggestions(panier) {
  const look = $(".look", tiroir);
  if (!panier.items.length || !routes.recommandations) return (look.hidden = true);
  try {
    let { products } = await api(`${routes.recommandations}.json?product_id=${panier.items[0].product_id}&limit=10`);
    // boutique neuve : Shopify n'a pas encore de recommandations, on propose le catalogue
    if (!products.length) products = (await api(`${routes.collections}/products.json?limit=12`)).products.map((p) => ({
      ...p, available: p.variants.some((v) => v.available), price: Math.round(parseFloat(p.variants[0].price) * 100),
      featured_image: p.images[0]?.src, url: `${routes.racine.replace(/\/$/, "")}/products/${p.handle}`,
    }));
    const dedans = new Set(panier.items.map((i) => i.product_id));
    const choix = products.filter((p) => p.available && !dedans.has(p.id)).slice(0, 6);
    look.hidden = !choix.length;
    $(".look-liste", tiroir).innerHTML = choix.map((p) => {
      const unique = p.variants.length === 1 && p.variants[0].available;
      const image = p.featured_image ? `<img src="${echapper(largeur(p.featured_image, 300))}" alt="" loading="lazy">` : "";
      const bouton = unique
        ? `<button type="button" class="ajout-rapide" data-id="${p.variants[0].id}" aria-label="${echapper(T.ajouter.replace("%s", p.title))}">${ICONE.plus}</button>`
        : `<a class="ajout-rapide" href="${echapper(p.url)}" aria-label="${echapper(T.voir_produit.replace("%s", p.title))}">${ICONE.plus}</a>`;
      return `<div class="sugg"><a href="${echapper(p.url)}" class="mini">${image}</a>${bouton}
        <a href="${echapper(p.url)}" class="sugg-nom">${echapper(p.title)}</a><p>${argent(p.price)}</p></div>`;
    }).join("");
  } catch {
    look.hidden = true;
  }
}

async function rendreTiroir(panier) {
  panier = panier || (await lirePanier());
  const n = panier.item_count;
  afficherCompte(n);
  $("#tiroir-titre").textContent = T.titre.replace("%n", n);
  $(".vide", tiroir).hidden = n > 0;
  $("footer", tiroir).hidden = $(".infos", tiroir).hidden = !n;
  $(".lignes", tiroir).innerHTML = panier.items.map(ligneHTML).join("");
  $(".commander", tiroir).textContent = `${T.commander} · ${argent(panier.total_price)}`;
  rendreSuggestions(panier);
}

async function ouvrirTiroir(panier) {
  await rendreTiroir(panier);
  retourFocus = document.activeElement;
  tiroir.inert = false;
  document.documentElement.classList.add("tiroir-ouvert");
  $(".fermer", tiroir).focus();
}
function fermerTiroir() {
  tiroir.inert = true;
  document.documentElement.classList.remove("tiroir-ouvert");
  retourFocus?.focus();
}
function signalerErreur() {
  const p = $(".erreur", tiroir);
  p.textContent = T.erreur;
  p.hidden = false;
}

$(".fermer", tiroir).addEventListener("click", fermerTiroir);
fond.addEventListener("click", fermerTiroir);
addEventListener("keydown", (e) => {
  if (tiroir.inert) return;
  if (e.key === "Escape") fermerTiroir();
  if (e.key === "Tab") {
    const f = $$("a[href], button:not(:disabled)", tiroir).filter((x) => x.offsetParent);
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
    else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
  }
});
tiroir.addEventListener("click", async (e) => {
  const q = e.target.closest("[data-qte]");
  const rapide = e.target.closest("button.ajout-rapide");
  try {
    if (q) await rendreTiroir(await api(`${routes.changement}.js`, { id: q.closest("li").dataset.cle, quantity: Number(q.dataset.qte) }));
    if (rapide) {
      await api(`${routes.ajout}.js`, { items: [{ id: Number(rapide.dataset.id), quantity: 1 }] });
      await rendreTiroir();
    }
  } catch {
    signalerErreur();
  }
});
lienPanier?.addEventListener("click", (e) => {
  if (document.body.querySelector(".panier")) return; // sur la page panier, on y reste
  e.preventDefault();
  ouvrirTiroir();
});

// Fiche : l'ajout passe par l'API ; sans script, le formulaire Shopify mène au panier.
document.addEventListener("submit", async (e) => {
  const form = e.target.closest(".form-produit");
  if (!form) return;
  e.preventDefault();
  const bouton = $('[type="submit"]', form);
  const express = e.submitter?.classList.contains("carre");
  bouton.disabled = true;
  try {
    const items = [new FormData(form).get("id"), ...autresCoches().map((a) => a.id)].map((id) => ({ id: Number(id), quantity: 1 }));
    await api(`${routes.ajout}.js`, { items });
    if (express) return void (location.href = "/checkout"); // carré de paiement express : droit au paiement Shopify
    lienPanier.classList.remove("rebond");
    void lienPanier.offsetWidth; // relance l'animation du badge
    lienPanier.classList.add("rebond");
    await ouvrirTiroir();
  } catch {
    await ouvrirTiroir();
    signalerErreur();
  } finally {
    bouton.disabled = false;
  }
});

// En-tête : menu (téléphone) et recherche instantanée (recherche prédictive Shopify) ; sans script, les liens mènent aux pages.
const menu = $(".menu-panneau"), boutonMenu = $(".menu-bouton"), rapide = $(".recherche-rapide");
let retourPanneau;
function basculer(el, ouvrir, cible) {
  if (!el) return;
  el.hidden = !ouvrir;
  if (el === menu) boutonMenu?.setAttribute("aria-expanded", ouvrir);
  document.documentElement.classList.toggle("panneau-ouvert", !menu?.hidden || !rapide?.hidden);
  if (ouvrir) { retourPanneau ??= document.activeElement; (cible || $("a, button, input", el)).focus(); }
  else if (menu?.hidden && rapide?.hidden) { retourPanneau?.focus(); retourPanneau = null; }
}
boutonMenu?.addEventListener("click", () => basculer(menu, true));
$$(".fermer-panneau").forEach((b) => b.addEventListener("click", () => basculer(b.closest("[role=dialog]"), false)));
rapide?.addEventListener("click", (e) => e.target === rapide && basculer(rapide, false));
$$(".ouvrir-recherche").forEach((a) => a.addEventListener("click", (e) => {
  if (!rapide || !routes.suggestions) return;
  e.preventDefault();
  basculer(menu, false);
  basculer(rapide, true, $("input[name=q]", rapide));
}));
addEventListener("keydown", (e) => {
  if (e.key !== "Escape") return;
  basculer(rapide, false);
  basculer(menu, false);
});
let attente;
$("input[name=q]", rapide)?.addEventListener("input", (e) => {
  clearTimeout(attente);
  const q = e.target.value.trim();
  const liste = $(".recherche-resultats", rapide);
  if (!q) return (liste.innerHTML = "");
  attente = setTimeout(async () => {
    try {
      const r = await api(`${routes.suggestions}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
      const produits = r.resources.results.products || [];
      if (e.target.value.trim() !== q) return; // une frappe plus récente a pris la main
      liste.innerHTML = produits.map((p) => `<li><a href="${echapper(p.url)}"><span class="mini">${p.image ? `<img src="${echapper(largeur(p.image, 120))}" alt="">` : ""}</span><span>${echapper(p.title)}<small>${argent(Math.round(parseFloat(p.price) * 100))}</small></span></a></li>`).join("")
        || `<li class="aucun">${echapper(T.aucun.replace("%s", q))}</li>`;
    } catch {}
  }, 180);
});

// état de départ du choix de coloris (épuisé dans la taille préchoisie)
majMulti();


// Motion : les blocs montent en douceur à leur entrée à l'écran, une seule fois, en décalé.
if (!calme && "IntersectionObserver" in window) {
  const obs = new IntersectionObserver((entrees) => {
    for (const en of entrees) {
      if (!en.isIntersecting) continue;
      en.target.classList.add("vu");
      obs.unobserve(en.target);
    }
  }, { rootMargin: "0px 0px -8% 0px" });
  $$(".grille li, .titre, .fiche > *, .galerie, .pied-haut > *, .texte > *, .marque-texte > *").forEach((el, i) => {
    el.classList.add("monte");
    el.style.setProperty("--delai", `${(i % 6) * 70}ms`);
    obs.observe(el);
  });
}

// Cookies : le choix est confié à l'API de confidentialité Shopify, que lisent les applis Google & YouTube,
// Meta et TikTok (Consent Mode v2 compris). Shopify décide aussi où le bandeau est requis (shouldShowBanner).
// Un autre bandeau déjà présent (celui de Shopify ou d'une appli) garde la priorité : le nôtre ne s'affiche pas.
const AUTRES_BANDEAUX = "#shopify-pc__banner, #onetrust-banner-sdk, #CybotCookiebotDialog, #axeptio_overlay, #didomi-host, #usercentrics-root, #pandectes-banner, #cmpbox, .cc-window, .cky-consent-container, #termly-code-snippet-support";
const autreBandeau = () => !!(window.privacyBanner || document.querySelector(AUTRES_BANDEAUX));
async function attendreAutreBandeau() {
  for (let i = 0; i < 8 && !autreBandeau(); i++) await new Promise((r) => setTimeout(r, 250)); // les bandeaux tiers arrivent après la page
  return autreBandeau();
}
const bandeau = $(".cookies");
if (bandeau && window.Shopify?.loadFeatures) {
  Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (erreur) => {
    if (erreur) return;
    const api = Shopify.customerPrivacy;
    const form = $(".cookies-choix", bandeau);
    const bouton = (n) => $(`[data-cookies="${n}"]`, bandeau);
    const CATEGORIES_COOKIES = ["analytics", "marketing", "preferences"];
    const detailler = (oui) => {
      form.hidden = !oui;
      bouton("choisir").hidden = oui;
      bouton("choisir").setAttribute("aria-expanded", oui);
      bouton("enregistrer").hidden = !oui;
    };
    const ouvrir = (detail) => {
      const actuel = api.currentVisitorConsent?.() || {};
      for (const n of CATEGORIES_COOKIES) form.elements[n].checked = actuel[n] === "yes";
      detailler(detail);
      bandeau.hidden = false;
    };
    bandeau.addEventListener("click", (e) => {
      const b = e.target.closest("[data-cookies]");
      if (!b) return;
      const action = b.dataset.cookies;
      if (action === "choisir") { detailler(true); form.elements.analytics.focus(); return; }
      const choix = {};
      for (const n of CATEGORIES_COOKIES) choix[n] = action === "enregistrer" ? form.elements[n].checked : action === "accepter";
      choix.sale_of_data = choix.marketing; // États-Unis : la revente de données suit le choix publicité
      api.setTrackingConsent(choix, () => { bandeau.hidden = true; });
    });
    // le pied de page rouvre le bandeau, choix détaillés visibles : retirer son accord est aussi simple que le donner
    $$(".ouvrir-cookies").forEach((b) => {
      b.hidden = false;
      b.addEventListener("click", () => {
        if (window.privacyBanner?.showPreferences) return window.privacyBanner.showPreferences();
        ouvrir(true); form.elements.analytics.focus();
      });
    });
    if (api.shouldShowBanner()) attendreAutreBandeau().then((autre) => autre || ouvrir(false));
  });
}

// Newsletter : adresse vérifiée avant l'envoi, avec le message de la page plutôt que la bulle du navigateur.
document.addEventListener("submit", (e) => {
  const form = e.target.closest(".inscription form");
  const champ = form && $('input[type="email"]', form);
  if (!champ || champ.checkValidity()) return;
  e.preventDefault();
  form.classList.add("invalide");
  champ.focus();
});
document.addEventListener("input", (e) => e.target.closest(".inscription form")?.classList.remove("invalide"));

// Paiement express : chaque bouton n'apparaît que si l'appareil sait payer ainsi (Apple Pay, Google Pay) ; PayPal toujours.
async function filtrerExpress(racine, tous = false) {
  appareil ??= (async () => {
    const apple = !!window.ApplePaySession?.canMakePayments?.();
    let google = false;
    if (!apple && window.PaymentRequest) {
      try {
        google = await new PaymentRequest(
          [{ supportedMethods: "https://google.com/pay", data: { apiVersion: 2, apiVersionMinor: 0, allowedPaymentMethods: [{ type: "CARD", parameters: { allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"], allowedCardNetworks: ["VISA", "MASTERCARD"] } }] } }],
          { total: { label: "MARGGI", amount: { currency: window.DEVISE || "EUR", value: "1.00" } } }
        ).canMakePayment();
      } catch {}
    }
    return { apple, google };
  })();
  const { apple, google } = await appareil;
  $$(".apple-pay", racine).forEach((b) => (b.hidden = !(tous || apple)));
  $$(".google-pay", racine).forEach((b) => (b.hidden = !(tous || google)));
}
const achat = $(".achat");
if (achat && $(".carre", achat)) filtrerExpress(achat, achat.hasAttribute("data-express-tous"));
